<template>
	<ul
		:class="{
			'flex flex-col': true,
			'!gap-0': props.isMiniCart
		}"
	>
		<template v-for="lineItem of props?.lineItems" :key="lineItem.Id">
			<SharedProductOrderItem
				:line-item="lineItem"
				:item-type="'product-minicart'"
			/>
		</template>
	</ul>
</template>

<script setup lang="ts">
import type { BasketItem } from "@nwt/norce-pwa/dist/runtime/types/api/shopping/basket";

const props = defineProps<{
	lineItems: BasketItem[];
	isMiniCart?: boolean;
	layoutType?: string; // minicart or order
}>();
</script>
